export type BoardId = number;

export const CLASSIC = 'CLASSIC' as const;
export const NEXTGEN = 'NEXTGEN' as const;

export type RoadmapType = typeof CLASSIC | typeof NEXTGEN;
